



































































import Vue from 'vue';
import StatisticsBlock from '@/components/StatisticsBlock.vue';
import {TicketApi} from '@/api/ticket-api';
import {Statistic} from '@/types/statistic';
import moment from 'moment';

export default Vue.extend({
  name: 'TicketStatistics',
  props: ['dialog', 'ticketToken'],
  components: {StatisticsBlock},
  data: () => ({
    sessions: [] as Statistic[],
    dateFormat: 'DD.MM.YYYY HH:mm'
  }),
  watch: {
    ticketToken(val) {
      if (val) {
        TicketApi.getStatistic(val).then(res => {
          this.sessions = res.data
              .map((val: Statistic) => ({
                ...val,
                datetimeStart: moment(val.datetimeStart),
                datetimeLast: moment(val.datetimeLast)
              }));
        });
      }
    }
  },
  computed: {
    sessionNum(): number {
      return this.sessions.length;
    },
    firstSessionStart(): string {
      return this.sessions.length > 0
          ? this.sessions[0].datetimeStart.format(this.dateFormat)
          : '-';
    },
    lastSessionEnd(): string {
      return this.sessions.length > 0
          ? this.sessions[this.sessions.length - 1].datetimeLast.format(this.dateFormat)
          : '-';
    },
    sessionTimeSum(): string | 0 {
      const sessionTimeSum = this.sessions.length > 0
          ? this.sessions
              .map(val => moment.duration(val.datetimeLast.diff(val.datetimeStart)))
              .reduce((acc, curr) => {
                acc.add(curr);
                return acc;
              })
          : 0;
      return typeof sessionTimeSum == 'number'
          ? sessionTimeSum
          : `${sessionTimeSum.hours()} ч ${sessionTimeSum.minutes()} мин`;
    },
    averageSessionTime(): string | 0 {
      const durationArray = this.sessions.length > 0
          ? this.sessions
              .map(val => moment.duration(val.datetimeLast.diff(val.datetimeStart)))
              .sort((a, b) => a.asHours() > b.asHours() ? 1 : -1)
          : 0;

      const averageDuration = typeof durationArray == 'number'
          ? durationArray
          : durationArray[durationArray.length > 1 ? Math.round(durationArray.length / 2) : 0];

      return typeof averageDuration == 'number'
          ? averageDuration
          : `${averageDuration.hours()} ч ${averageDuration.minutes()} мин`;
    }
  }
});
